/**
 * @generated SignedSource<<647f27225938749ca8d0464508b05734>>
 * @relayHash 3ec440c42b9e10f77615efd9c7d41d81
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f4b72a4cc2548d0372d93ed64b070479b3d0aa9c4447f85b0857aedaabb05f3

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type overviewPageQuery$variables = {
  boardId?: string | null | undefined;
  projectKey?: string | null | undefined;
};
export type overviewPageQuery$data = {
  readonly jira: {
    readonly reportsPage: {
      readonly categories: ReadonlyArray<{
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
      } | null | undefined>;
    };
  };
};
export type overviewPageQuery = {
  response: overviewPageQuery$data;
  variables: overviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  },
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "overviewPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "concreteType": "JiraReportsPage",
                "kind": "LinkedField",
                "name": "reportsPage",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraReportCategory",
                      "kind": "LinkedField",
                      "name": "categories",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v3/*: any*/),
                          "action": "THROW",
                          "path": "jira.reportsPage.categories.name"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "reportCategory_reportsOverviewPage"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.reportsPage.categories"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.reportsPage"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "overviewPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraReportsPage",
            "kind": "LinkedField",
            "name": "reportsPage",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraReportCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "concreteType": "JiraReport",
                    "kind": "LinkedField",
                    "name": "reports",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "imageUrl"
                      },
                      (v4/*: any*/)
                    ]
                  },
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2f4b72a4cc2548d0372d93ed64b070479b3d0aa9c4447f85b0857aedaabb05f3",
    "metadata": {},
    "name": "overviewPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "92d181d6e444a08bef5441937ce897ef";

export default node;
